module.exports = __webpack_public_path__ + "img/maxresdefault.e132fcb2.jpg";